<template>
  <list
    v-if="loadingStatus === null || loadingStatus === true"
    v-show="loadingStatus === true"
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
    @error="loadingStatus = false"
    @succress="loadingStatus = true"
  />
  <div v-else-if="loadingStatus === false">
    <h4 class="text-error">Установите в журнале плановый урок</h4>
  </div>
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    //надо получить группу!
    this.itemLink = `business/timetables/${this.id}/works`;
    this.setLink = `business/timetables/${this.id}/works`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      loadingStatus: null,
      val: [],
      modalCreate: "client_group",
      fields: [
        {
          col: "col-12 col-md-8",
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
        },

        {
          col: "col-12 col-md-4",
          key: "given_seconds",
          label: "Сколько секунд на решение",
          type: "mask",
          mask: "###",
          textType: "number",
        },
        {
          col: "col-12 col-md-12",
          key: "description",
          label: "Краткое описание задания",
          type: "textarea",
          textType: "text",
        },
        {
          col:'col-12 col-md-12',
          key: "autocheck",
          label: "Автопроверка",
          type: "checkbox",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_work",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "title",
          title: "Задание",
          checkbox: false,
        },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
